import { render, staticRenderFns } from "./SetupGuide.vue?vue&type=template&id=0d45e58a"
import script from "./SetupGuide.vue?vue&type=script&lang=ts"
export * from "./SetupGuide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports